"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var axios_1 = require("axios");
var ContextTokenService = /** @class */ (function () {
    function ContextTokenService(token, baseURL) {
        this.token = token;
        this.baseURL = baseURL;
        this.contextTokens = {};
        this.apiClient = axios_1.default.create({
            baseURL: baseURL,
            headers: {
                Authorization: token,
            },
        });
    }
    ContextTokenService.prototype.getContextToken = function (groupId) {
        var contextToken = this.contextTokens[groupId];
        return Promise.resolve(contextToken || this.requestContextToken(groupId));
    };
    ContextTokenService.prototype.getContextTokens = function (groupIds) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var idsToRequest, storedTokens;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        idsToRequest = groupIds.filter(function (id) { return !_this.contextTokens[id]; });
                        if (!idsToRequest.length) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.requestContextTokens(idsToRequest)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, groupIds.map(function (id) { return _this.contextTokens[id]; })];
                    case 2:
                        storedTokens = groupIds
                            .filter(function (id) { return !!_this.contextTokens[id]; })
                            .map(function (id) { return _this.contextTokens[id]; });
                        return [2 /*return*/, Promise.resolve(storedTokens)];
                }
            });
        });
    };
    ContextTokenService.prototype.requestContextToken = function (groupId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.requestContextTokens([groupId])];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.contextTokens[groupId]];
                }
            });
        });
    };
    ContextTokenService.prototype.requestContextTokens = function (groupIds) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiClient.post('/v1/integration/feed/tokens', {
                            groupIds: groupIds,
                        })];
                    case 1:
                        data = (_a.sent()).data;
                        this.contextTokens = tslib_1.__assign({}, this.contextTokens, data.tokens);
                        return [2 /*return*/, this.contextTokens];
                }
            });
        });
    };
    return ContextTokenService;
}());
exports.ContextTokenService = ContextTokenService;
//# sourceMappingURL=context-token.service.js.map